<template>
  <el-form
    :model="form"
    ref="form">
    <el-form-item
      :label="L10n('title')"
      prop="title"
      :rules="getValidationRule('required,minLength')"
      class="material-style">
      <el-input
        ref="firstField"
        :value="form.title"
        @input="form.title = valueTrimLeft($event)"
        @change="updateModelItem('title', { required: true })"/>
    </el-form-item>
    <el-form-item
      prop="isActive"
      class="material-style">
      <el-checkbox
        v-model="form.isActive"
        @change="updateModelItem('isActive')">
        {{L10n('is-active')}}
      </el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormBanks',
  mixins: [Form]
}
</script>
